import React from "react";

const CourseLocation = () => {
  return (
    <div className="rounded-lg overflow-hidden shadow-lg">
      <iframe
        title="Course Location"
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2695.40705460138!2d8.7474032!3d47.5014634!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x479a998dccf92015%3A0x7fc996d01a40adac!2sR%C3%B6merstrasse%2076%2C%208404%20Winterthur%2C%20Switzerland!5e0!3m2!1sen!2smk!4v1737047981954!5m2!1sen!2smk"
        width="100%"
        height="450"
        referrerPolicy="no-referrer-when-downgrade"
        style={{ border: 0 }}
        allowFullScreen={true}
        loading="lazy"
      ></iframe>
    </div>
  );
};

export default CourseLocation;
